import { useQueryClient } from "@tanstack/react-query";
import { DeletePopup } from "components/Admin/Pages/DeletePopup/DeletePopup";
import { useCallback } from "react";
import { userService } from "services/userService";

export const DeleteUser: React.FC = () => {
  const queryClient = useQueryClient();

  const onSuccess = useCallback(
    () => {
      queryClient.invalidateQueries({ queryKey: ["tasks"] });
      queryClient.invalidateQueries({ queryKey: ["orders"] });
    },
    [queryClient]
  );

  return (
    <DeletePopup
      deleteQuery={userService.delete}
      onSuccess={onSuccess}
      onSuccessNavigate="/users"
    />
  );
};
